// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__1hhFG"};